var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"name",staticStyle:{"border-bottom":"1px solid #F0F0F0"},style:({background:'white'})},[_c('div',{staticClass:"colorBar",style:({background:'white'})}),_c('el-tooltip',{attrs:{"placement":"top","effect":"dark"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.data.catalogName)),_c('br'),_vm._v(_vm._s(_vm.data.name))]),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{style:({
        width: _vm.leftWidth,
        float:'left',
        position: 'relative',
        overflow: 'hidden',
        'white-space':'nowrap',
        'text-overflow': 'ellipsis'
      })},[_vm._v(_vm._s(_vm.data.catalogName))]),_c('div',{style:({
        width: _vm.rightWidth,
        float: 'left',
        position: 'relative',
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
      })},[_vm._v(_vm._s(_vm.data.name))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }